import React, { useState } from "react";
import { CalendarClock, X } from "lucide-react";
import { toast } from "sonner";
import { adminApi } from "../../lib/api";
import { inputCls } from "../ui";

const local = (d) => {
  const t = new Date(d);
  t.setMinutes(t.getMinutes() - t.getTimezoneOffset());
  return t.toISOString().slice(0, 16);
};

/** Pick a time and the 15-minute scheduler sends it. */
export function CampaignSchedule({ campaign, beforeSchedule, onChanged, disabled }) {
  const [when, setWhen] = useState(local(Date.now() + 24 * 3600 * 1000));
  const [busy, setBusy] = useState(false);

  const schedule = async () => {
    setBusy(true);
    try {
      const id = await beforeSchedule();
      const r = await adminApi.post(`/admin/marketing/campaigns/${id}/schedule`, {
        scheduled_at: new Date(when).toISOString(),
      });
      toast.success("Scheduled", { description: `Goes out ${new Date(r.data.scheduled_at).toLocaleString()}` });
      onChanged(id);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not schedule");
    } finally {
      setBusy(false);
    }
  };

  const cancel = async () => {
    setBusy(true);
    try {
      await adminApi.delete(`/admin/marketing/campaigns/${campaign.id}/schedule`);
      toast.success("Schedule cancelled - it is a draft again");
      onChanged(campaign.id);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not cancel");
    } finally {
      setBusy(false);
    }
  };

  if (campaign.status === "scheduled") {
    return (
      <div className="flex flex-wrap items-center gap-3 text-xs" data-testid="campaign-scheduled">
        <CalendarClock className="h-4 w-4 gold-text" />
        <span>Sending <strong>{new Date(campaign.scheduled_at).toLocaleString()}</strong> (within 15 minutes of that time)</span>
        <button onClick={cancel} disabled={busy} className="btn-outline-nq inline-flex items-center gap-1 px-3 py-1.5 text-[11px]" data-testid="campaign-unschedule">
          <X className="h-3.5 w-3.5" /> Cancel schedule
        </button>
      </div>
    );
  }
  return (
    <div className="flex flex-wrap items-end gap-2">
      <label className="text-[11px] text-[color:var(--nq-stone)]">
        Or send later
        <input type="datetime-local" value={when} onChange={(e) => setWhen(e.target.value)} disabled={disabled} className={`${inputCls} mt-1`} data-testid="campaign-schedule-at" />
      </label>
      <button onClick={schedule} disabled={busy || disabled || !when} className="btn-outline-nq inline-flex items-center gap-2 px-4 py-2 text-xs disabled:opacity-50" data-testid="campaign-schedule">
        <CalendarClock className="h-3.5 w-3.5" /> Schedule
      </button>
    </div>
  );
}
